<template>    
    <v-form ref="form">
        <v-dialog v-if="isView" v-model="isView" persistent>        
            <v-card class="mt-3 pa-1">
                <Title title="グループ">
                    <v-spacer />
                    <TitleButton
                        color="primary"
                        icon="mdi-floppy"
                        name="保存"
                        @click="onClickSave()" />
                    <TitleButton
                        color="primary"
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView=false" />
                </Title>
                <v-container fluid>
                    <v-row dense>
                        <v-col>
                            <v-text-field 
                                v-model="editValues.groupName" 
                                clearable
                                dense
                                label="名称"
                                outlined 
                                type="text" 
                                persistent-hint
                                hint="グループ名を入力します。(必須)" 
                                :rules="[validatorNameRequire]" />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card> 
        </v-dialog>
    </v-form>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Title,
            TitleButton
        },
        props: [
        ],
        computed: {
            userUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            userData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            /**
             * 所有する全グループ
             * {
             *      body: グループデータ,
             *      users: グループ所属の全ユーザー
             *      {
             *          body: ユーザーデータ,
             *          userInfo: {
             *              userName:
             *              avaterURL:
             *          }
             *      },
             * }
             */
            groups: function () {
                return this.$store.getters["managementItems/groups"]
            },
            /**
             * 所属する全グループ
             * {
             *      body: グループデータ,
             *      ownerInfo: { 所有者情報
             *          userName:
             *          avaterURL:
             *      }
             *      users: グループ所属の全ユーザー
             *      {
             *          body: ユーザーデータ,
             *          userInfo: {
             *              userName:
             *              avaterURL:
             *          }
             *      },
             * }
             */
            belongGroups: function () {
                return this.$store.getters["managementItems/belongGroups"]
            }
        },
        data: function () {
            return {
                authorityActiveColor: "yellow lighten-1 black--text",
                isView:false,
                disabled: false,
                editValues:null,
                authorities: [
                    {text:"参照不可", value:0},
                    {text:"参照可", value:1},
                    {text:"作業可", value:2}
                ],
                validatorNameRequire: value => !!value || '必須入力です。',
                validatorNameLength: value => value.length <= 20 || '20文字以内で入力して下さい。',
            }
        },
        methods: {
            /**
             * このダイアログを表示
             */
            show: function(group){
                this.targetGroup = group
                if (group == null) {
                    this.editValues = {
                        groupName: "",
                    }
                } else {
                    this.editValues = {
                        groupName: group.groupName,
                    }
                }
                this.isView = true
            },
            /**
             * 保存ボタン押下時
             */
            onClickSave: function () {
                if (!this.$refs.form.validate()) {
                    return
                }
                const self = this
                const currentDateTime = this.df_currentDateTime()
                var isNewGroup = false
                var group = this.targetGroup
                if (group == null) {
                    isNewGroup = true
                    var groupNo = 1
                    if (this.groups.length > 0) {
                        groupNo = Math.max(...this.groups.map(m => m.body.groupNo)) + 1
                    }
                    group = {
                        version: "2.0.0",
                        ownerUserUID: this.userUID,
                        groupNo: groupNo,
                        groupName: this.editValues.groupName,
                        registeredDateTime: currentDateTime,
                        updatedDateTime: "",
                    }
                } else {
                    group.groupName = this.editValues.groupName,
                    group.updatedDateTime = currentDateTime
                }

                /** グループの登録 */
                const docGroup = db.collection("users").doc(this.userUID).collection("groups").doc(""+group.groupNo)
                docGroup.set(group).then(function(){
                    self.$store.commit("notification", {message:"グループを登録しました。", isError:false})
                    if (isNewGroup) {
                        self.$store.commit("managementItems/addGroup", group)
                        /** 自身をグループユーザーとして登録 */
                        const groupUser = {
                            version: "2.0.0",
                            ownerUserUID: self.userUID,
                            groupNo: group.groupNo,
                            userUID: self.userUID,
                            state: 1,
                            authorities: [
                                "place", 
                                "place.work.browse", 
                                "place.work.record", 
                                "place.environment.browse", 
                                "place.environment.record"
                            ],
                            registeredDateTime: currentDateTime,
                            updatedDateTime: ""
                        }
                        docGroup.collection("users").doc(self.userUID).set(groupUser).then(function(){
                            self.$store.commit("managementItems/addGroupUser", {group: self.groups[self.groups.length - 1], user: groupUser})
                            self.$store.commit("notification", {message:"グループユーザーを登録しました。", isError:false})
                        }).catch (function(error) {
                            console.log(error)
                            self.$store.commit("notification", {message:"グループユーザーの登録に失敗しました。", isError:true})
                            self.mi_writeLog("MaintenanceGroup/onClickSave", "グループユーザーの登録に失敗しました。("+error+")")
                        })
                    }
                }).catch(function(error){
                    console.log(error)
                    self.$store.commit("notification", {message:"グループの作成に失敗しました。", isError:true})
                    self.mi_writeLog("MaintenanceGroup/onClickSave", "グループの作成に失敗しました。("+error+")")
                })
                                
                this.isView = false
            }
        }
    }
</script>
